export default "__VITE_ASSET__BcFgAxE$__"